export default {
  title: 'News',
  createPost: 'Create Post',
  titleLabel: 'Title',
  contentLabel: 'Content',
  viewerLabel: 'Viewer',
  customizerLabel: 'Customizer',
  managerLabel: 'Manager',
  close: 'Close',
  save: 'Save',
  headerTitle: 'Title',
  headerContent: 'Content',
  headerProfiles: 'Profiles',
  headerCreator: 'Creator',
  headerCreated: 'Created',
  headerActions: 'Actions',
  noData: 'No data',
  deleteConfirm: 'Are you sure you want to delete this post?',
  notAvailable: 'N/A'
}
